module.exports = "/_next/static/images/complaint-channel-96526a3f2bbf62eddf74f0ed7655e1d3.png";